import { ModuleNames } from "@ag-grid-community/core";
import { InfiniteRowModel } from "./infiniteRowModel/infiniteRowModel";
export var InfiniteRowModelModule = {
    moduleName: ModuleNames.InfiniteRowModelModule,
    rowModels: { infinite: InfiniteRowModel }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-community/infinite-row-model/dist/es6/infiniteRowModelModule.js
// module id = 3094
// module chunks = 0